export default __webpack_public_path__ + "static/media/NursesBG.416bbbe7.jpg";